module.exports = __webpack_public_path__ + "static/media/loader.f6076e2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/loadingScreen/loader.svg
// module id = 1996
// module chunks = 0